<div class="container" id="wrap">
    <form name="form" role="form" (ngSubmit)="f.form.valid && accountConfirm()" #f="ngForm" novalidate class="">
        <div class="row">
            <div class="col-lg-12">
                <br />
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="col-lg-3"></div>
                <div class="col-lg-6 text-center ">
                    <img src="assets/images/logos/ic.svg" style="width: 70%;">
                </div>
                <div class="col-lg-3"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <br />
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="col-lg-3"></div>
                <div class="col-lg-6 ">
                    <div class="row bg-registro-light" style="overflow: hidden;">
                        <div class="col-lg-12">
                            <br />
                        </div>
                        <div class="col-lg-12">

                            <div class="col-lg-2"></div>
                            <div class="col-lg-8 text-center ">
                                <p class="titulo_bold">Verificación de cuenta</p>
                            </div>

                            <div class="col-lg-2"></div>

                        </div>
                        <div class="col-lg-12">
                            <div class="col-lg-2"></div>
                            <div class="col-lg-8 text-center">

                                <p class="subtitulo_normal">
                                    Para verificar tu cuenta, hemos enviado un código al correo
                                    electrónico ingresado.
                                </p>

                            </div>
                            <div class="col-lg-2"></div>
                        </div>

                        <div class="col-lg-12">
                            <div class="col-lg-2"></div>
                            <div class="form-group  col-lg-8">
                                <label class="control-label">Ingresa tu código <small
                                        class="text-muted"><em></em></small></label>


                                <div class="row" style="overflow: hidden;">
                                    <input type="text" autofocus (keyup)="updateName();" placeholder=""
                                        class="form-control input-md col-lg input-code-single id-num-verificacion"
                                        name="code1" [(ngModel)]="cod1" #code1="ngModel" maxlength="1" minlength="1">
                                    <input type="text" (keyup)="updateName()" placeholder=""
                                        class="form-control input-md col-lg input-code-single id-num-verificacion"
                                        name="code2" [(ngModel)]="cod2" #code2="ngModel" maxlength="1" minlength="1">
                                    <input type="text" (keyup)="updateName()" placeholder=""
                                        class="form-control input-md col-lg input-code-single id-num-verificacion"
                                        name="code3" [(ngModel)]="cod3" #code3="ngModel" maxlength="1" minlength="1">
                                    <input type="text" (keyup)="updateName()" placeholder=""
                                        class="form-control input-md col-lg input-code-single id-num-verificacion"
                                        name="code4" [(ngModel)]="cod4" #code4="ngModel" maxlength="1" minlength="1">
                                    <input type="text" (keyup)="updateName()" placeholder=""
                                        class="form-control input-md col-lg input-code-single id-num-verificacion"
                                        name="code5" [(ngModel)]="cod5" #code5="ngModel" maxlength="1" minlength="1">
                                    <input type="text" (keyup)="updateName()" placeholder=""
                                        class="form-control input-md col-lg input-code-single id-num-verificacion"
                                        name="code6" [(ngModel)]="cod6" #code6="ngModel" maxlength="1" minlength="1">
                                </div>

                                <input type="hidden" placeholder="******" class="form-control input-md pwd0" name="code"
                                    [(ngModel)]="codeCognito" #code="ngModel" maxlength="6" minlength="6" required>
                                <div *ngIf="f.submitted && code?.invalid"
                                    class="alert alert-danger col-lg-12 animated fadeIn p5top p5bottom m10bottom ">
                                    <div *ngIf="code?.errors.required"><i class="fa fa-exclamation-triangle"></i> Debe
                                        ingresar el
                                        código de confirmacion enviado a su casilla de
                                        correo.</div>
                                    <div *ngIf="code?.errors.minlength"><i class="fa fa-exclamation-triangle"></i> El
                                        código debe
                                        contener mínimo 6 caracteres</div>
                                    <div *ngIf="code?.errors.maxlength"><i class="fa fa-exclamation-triangle"></i> El
                                        código debe
                                        contener máximo 6 caracteres</div>
                                </div>
                                <div *ngIf="f.submitted && invalidCode"
                                    class="alert alert-danger col-lg-12 animated fadeIn p5top p5bottom m10bottom">
                                    <i class="fa fa-exclamation-triangle"></i> El código no coincide con el enviado.
                                </div>
                            </div>
                            <div class="col-lg-2"></div>
                        </div>
                        <div class="col-lg-12">

                            <div *ngIf="f.submitted && invalidCode"
                                class="invalid-feedback alert alert-danger col-lg-12 animated fadeIn f12 p5top p5bottom m10bottom">
                                <div *ngIf="invalidCode"><i class="fa fa-exclamation-triangle"></i> El codigo enviado o
                                    la contraseña es
                                    incorrecto.</div>
                            </div>

                        </div>

                        <div class="col-lg-12 mobile-content-show">
                            <div class="col-lg-6">
                                <button id="confirmar" class=" btn btn-lg btn-orange btn-block">Confirmar</button>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <br />
                        </div>
                    </div>
                    <div class="row mobile-content-show">
                        <div class="col-lg-12">
                            <br />
                        </div>
                        <div class="col-lg-12">
                            <div class="col-lg-12">
                                <a (click)="resendCode()"
                                    class="btn btn-lg col-lg-12 btn-atras">Reenviar código</a>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 mobile-content-hide">
                            <div class="col-lg-12">
                                <br />
                            </div>
                            <div class="col-lg-12">

                                <div class="col-lg-6">
                                    <a (click)="resendCode()" class="btn btn-lg btn-atras">Reenviar
                                        código</a>
                                </div>

                                <div class="col-lg-6">
                                    <button id="confirmar" class=" btn btn-lg btn-orange btn-block">Confirmar</button>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
                <div class="col-lg-3"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <br />
            </div>
        </div>
    </form>
</div>